import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EmbeddingRerankerMethod = /*#__PURE__*/function (EmbeddingRerankerMethod) {
  EmbeddingRerankerMethod[EmbeddingRerankerMethod["EMBEDDING_RERANKER_METHOD_INVALID"] = 0] = "EMBEDDING_RERANKER_METHOD_INVALID";
  EmbeddingRerankerMethod[EmbeddingRerankerMethod["EMBEDDING_RERANKER_METHOD_PREQUERY_HYDE"] = 1] = "EMBEDDING_RERANKER_METHOD_PREQUERY_HYDE";
  return EmbeddingRerankerMethod;
}(EmbeddingRerankerMethod || {});
var EmbeddingSourceType = /*#__PURE__*/function (EmbeddingSourceType) {
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_INVALID"] = 0] = "EMBEDDING_SOURCE_TYPE_INVALID";
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_USER_INPUT"] = 1] = "EMBEDDING_SOURCE_TYPE_USER_INPUT";
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_WEBSITE"] = 2] = "EMBEDDING_SOURCE_TYPE_WEBSITE";
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_BUSINESS_PROFILE"] = 3] = "EMBEDDING_SOURCE_TYPE_BUSINESS_PROFILE";
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_CATEGORIES"] = 4] = "EMBEDDING_SOURCE_TYPE_CATEGORIES";
  return EmbeddingSourceType;
}(EmbeddingSourceType || {});
var EmbeddingVendorModel = /*#__PURE__*/function (EmbeddingVendorModel) {
  EmbeddingVendorModel[EmbeddingVendorModel["EMBEDDING_MODEL_INVALID"] = 0] = "EMBEDDING_MODEL_INVALID";
  EmbeddingVendorModel[EmbeddingVendorModel["EMBEDDING_MODEL_OPENAI_ADA_V2"] = 1] = "EMBEDDING_MODEL_OPENAI_ADA_V2";
  EmbeddingVendorModel[EmbeddingVendorModel["EMBEDDING_MODEL_GOOGLE_GECKO_V2"] = 2] = "EMBEDDING_MODEL_GOOGLE_GECKO_V2";
  EmbeddingVendorModel[EmbeddingVendorModel["EMBEDDING_MODEL_TUNED_CATEGORY"] = 3] = "EMBEDDING_MODEL_TUNED_CATEGORY";
  return EmbeddingVendorModel;
}(EmbeddingVendorModel || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var KnowledgeSourceConfigType = /*#__PURE__*/function (KnowledgeSourceConfigType) {
  KnowledgeSourceConfigType[KnowledgeSourceConfigType["KNOWLEDGE_SOURCE_CONFIG_TYPE_INVALID"] = 0] = "KNOWLEDGE_SOURCE_CONFIG_TYPE_INVALID";
  KnowledgeSourceConfigType[KnowledgeSourceConfigType["KNOWLEDGE_SOURCE_CONFIG_TYPE_BUSINESS_PROFILE"] = 1] = "KNOWLEDGE_SOURCE_CONFIG_TYPE_BUSINESS_PROFILE";
  KnowledgeSourceConfigType[KnowledgeSourceConfigType["KNOWLEDGE_SOURCE_CONFIG_TYPE_CUSTOM_DATA"] = 2] = "KNOWLEDGE_SOURCE_CONFIG_TYPE_CUSTOM_DATA";
  KnowledgeSourceConfigType[KnowledgeSourceConfigType["KNOWLEDGE_SOURCE_CONFIG_TYPE_WEBSITE_SCRAPE"] = 3] = "KNOWLEDGE_SOURCE_CONFIG_TYPE_WEBSITE_SCRAPE";
  return KnowledgeSourceConfigType;
}(KnowledgeSourceConfigType || {});
var TrainingProgress = /*#__PURE__*/function (TrainingProgress) {
  TrainingProgress[TrainingProgress["TRAINING_INVALID"] = 0] = "TRAINING_INVALID";
  TrainingProgress[TrainingProgress["TRAINING_QUEUED"] = 1] = "TRAINING_QUEUED";
  TrainingProgress[TrainingProgress["TRAINING_IN_PROGRESS"] = 2] = "TRAINING_IN_PROGRESS";
  TrainingProgress[TrainingProgress["TRAINING_DONE"] = 3] = "TRAINING_DONE";
  return TrainingProgress;
}(TrainingProgress || {});
var WebsiteScrapeConfigCrawlMode = /*#__PURE__*/function (WebsiteScrapeConfigCrawlMode) {
  WebsiteScrapeConfigCrawlMode[WebsiteScrapeConfigCrawlMode["WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_INVALID"] = 0] = "WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_INVALID";
  WebsiteScrapeConfigCrawlMode[WebsiteScrapeConfigCrawlMode["WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SINGLE"] = 1] = "WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SINGLE";
  WebsiteScrapeConfigCrawlMode[WebsiteScrapeConfigCrawlMode["WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE"] = 2] = "WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_RECURSIVE";
  WebsiteScrapeConfigCrawlMode[WebsiteScrapeConfigCrawlMode["WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SITEMAP"] = 3] = "WEBSITE_SCRAPE_CONFIG_CRAWL_MODE_SITEMAP";
  return WebsiteScrapeConfigCrawlMode;
}(WebsiteScrapeConfigCrawlMode || {});
var WebsiteScrapeConfigProgress = /*#__PURE__*/function (WebsiteScrapeConfigProgress) {
  WebsiteScrapeConfigProgress[WebsiteScrapeConfigProgress["WEBSITE_SCRAPE_CONFIG_PROGRESS_INVALID"] = 0] = "WEBSITE_SCRAPE_CONFIG_PROGRESS_INVALID";
  WebsiteScrapeConfigProgress[WebsiteScrapeConfigProgress["WEBSITE_SCRAPE_CONFIG_PROGRESS_QUEUED"] = 1] = "WEBSITE_SCRAPE_CONFIG_PROGRESS_QUEUED";
  WebsiteScrapeConfigProgress[WebsiteScrapeConfigProgress["WEBSITE_SCRAPE_CONFIG_PROGRESS_IN_PROGRESS"] = 2] = "WEBSITE_SCRAPE_CONFIG_PROGRESS_IN_PROGRESS";
  WebsiteScrapeConfigProgress[WebsiteScrapeConfigProgress["WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE"] = 3] = "WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE";
  return WebsiteScrapeConfigProgress;
}(WebsiteScrapeConfigProgress || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ChatMessageRole = /*#__PURE__*/function (ChatMessageRole) {
  ChatMessageRole[ChatMessageRole["CHAT_MESSAGE_ROLE_INVALID"] = 0] = "CHAT_MESSAGE_ROLE_INVALID";
  ChatMessageRole[ChatMessageRole["CHAT_MESSAGE_ROLE_USER"] = 1] = "CHAT_MESSAGE_ROLE_USER";
  ChatMessageRole[ChatMessageRole["CHAT_MESSAGE_ROLE_ASSISTANT"] = 2] = "CHAT_MESSAGE_ROLE_ASSISTANT";
  return ChatMessageRole;
}(ChatMessageRole || {});
var FunctionExecutionJobStatus = /*#__PURE__*/function (FunctionExecutionJobStatus) {
  FunctionExecutionJobStatus[FunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_INVALID"] = 0] = "FUNCTION_EXECUTION_JOB_STATUS_INVALID";
  FunctionExecutionJobStatus[FunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_QUEUED"] = 1] = "FUNCTION_EXECUTION_JOB_STATUS_QUEUED";
  FunctionExecutionJobStatus[FunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_RUNNING"] = 2] = "FUNCTION_EXECUTION_JOB_STATUS_RUNNING";
  FunctionExecutionJobStatus[FunctionExecutionJobStatus["FUNCTION_EXECUTION_JOB_STATUS_COMPLETE"] = 3] = "FUNCTION_EXECUTION_JOB_STATUS_COMPLETE";
  return FunctionExecutionJobStatus;
}(FunctionExecutionJobStatus || {});
var RefreshAccountGroupWebsiteEmbeddingsProgress = /*#__PURE__*/function (RefreshAccountGroupWebsiteEmbeddingsProgress) {
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_INVALID"] = 0] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_INVALID";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_SCRAPE_STARTED"] = 1] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_SCRAPE_STARTED";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_ANALYSIS_STARTED"] = 2] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_ANALYSIS_STARTED";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_COMPLETE"] = 3] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_COMPLETE";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_FAILED"] = 4] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_FAILED";
  return RefreshAccountGroupWebsiteEmbeddingsProgress;
}(RefreshAccountGroupWebsiteEmbeddingsProgress || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Embedding {
  static fromProto(proto) {
    let m = new Embedding();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = EmbeddingMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class EmbeddingCitation {
  static fromProto(proto) {
    let m = new EmbeddingCitation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class EmbeddingMetadata {
  static fromProto(proto) {
    let m = new EmbeddingMetadata();
    m = Object.assign(m, proto);
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    if (proto.relationship) {
      m.relationship = EmbeddingRelationship.fromProto(proto.relationship);
    }
    if (proto.sourceType) {
      m.sourceType = enumStringToValue$5(EmbeddingSourceType, proto.sourceType);
    }
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue$5(EmbeddingVendorModel, proto.vendorModel);
    }
    if (proto.citation) {
      m.citation = EmbeddingCitation.fromProto(proto.citation);
    }
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? this.updatedAt.toApiJson() : this.updatedAt;
    }
    if (typeof this.relationship !== 'undefined' && this.relationship !== null) {
      toReturn['relationship'] = 'toApiJson' in this.relationship ? this.relationship.toApiJson() : this.relationship;
    }
    if (typeof this.sourceType !== 'undefined') {
      toReturn['sourceType'] = this.sourceType;
    }
    if (typeof this.sourceFeature !== 'undefined') {
      toReturn['sourceFeature'] = this.sourceFeature;
    }
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.citation !== 'undefined' && this.citation !== null) {
      toReturn['citation'] = 'toApiJson' in this.citation ? this.citation.toApiJson() : this.citation;
    }
    if (typeof this.disabled !== 'undefined') {
      toReturn['disabled'] = this.disabled;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
class EmbeddingRelationship {
  static fromProto(proto) {
    let m = new EmbeddingRelationship();
    m = Object.assign(m, proto);
    if (proto.accountGroup) {
      m.accountGroup = EmbeddingRelationshipAccountGroup.fromProto(proto.accountGroup);
    }
    if (proto.partner) {
      m.partner = EmbeddingRelationshipPartner.fromProto(proto.partner);
    }
    if (proto.admin) {
      m.admin = EmbeddingRelationshipAdmin.fromProto(proto.admin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroup !== 'undefined' && this.accountGroup !== null) {
      toReturn['accountGroup'] = 'toApiJson' in this.accountGroup ? this.accountGroup.toApiJson() : this.accountGroup;
    }
    if (typeof this.partner !== 'undefined' && this.partner !== null) {
      toReturn['partner'] = 'toApiJson' in this.partner ? this.partner.toApiJson() : this.partner;
    }
    if (typeof this.admin !== 'undefined' && this.admin !== null) {
      toReturn['admin'] = 'toApiJson' in this.admin ? this.admin.toApiJson() : this.admin;
    }
    return toReturn;
  }
}
class EmbeddingRelationshipAccountGroup {
  static fromProto(proto) {
    let m = new EmbeddingRelationshipAccountGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class EmbeddingRelationshipAdmin {
  static fromProto(proto) {
    let m = new EmbeddingRelationshipAdmin();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class EmbeddingRelationshipPartner {
  static fromProto(proto) {
    let m = new EmbeddingRelationshipPartner();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class Tag {
  static fromProto(proto) {
    let m = new Tag();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class NamespaceAccountGroupNamespace {
  static fromProto(proto) {
    let m = new NamespaceAccountGroupNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class NamespaceAdminNamespace {
  static fromProto(proto) {
    let m = new NamespaceAdminNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class App {
  static fromProto(proto) {
    let m = new App();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.knowledgeBaseKeys) {
      m.knowledgeBaseKeys = proto.knowledgeBaseKeys.map(KnowledgeBaseKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.configurationUrl !== 'undefined') {
      toReturn['configurationUrl'] = this.configurationUrl;
    }
    if (typeof this.knowledgeBaseKeys !== 'undefined' && this.knowledgeBaseKeys !== null) {
      toReturn['knowledgeBaseKeys'] = 'toApiJson' in this.knowledgeBaseKeys ? this.knowledgeBaseKeys.toApiJson() : this.knowledgeBaseKeys;
    }
    if (typeof this.appType !== 'undefined') {
      toReturn['appType'] = this.appType;
    }
    if (typeof this.appTypeName !== 'undefined') {
      toReturn['appTypeName'] = this.appTypeName;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    return toReturn;
  }
}
class AppKey {
  static fromProto(proto) {
    let m = new AppKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigBusinessProfileConfig {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigBusinessProfileConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigCustomDataConfig {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigCustomDataConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    return toReturn;
  }
}
class KnowledgeBase {
  static fromProto(proto) {
    let m = new KnowledgeBase();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.knowledgeSourceKeys) {
      m.knowledgeSourceKeys = proto.knowledgeSourceKeys.map(KnowledgeSourceKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.knowledgeSourceKeys !== 'undefined' && this.knowledgeSourceKeys !== null) {
      toReturn['knowledgeSourceKeys'] = 'toApiJson' in this.knowledgeSourceKeys ? this.knowledgeSourceKeys.toApiJson() : this.knowledgeSourceKeys;
    }
    return toReturn;
  }
}
class KnowledgeBaseKey {
  static fromProto(proto) {
    let m = new KnowledgeBaseKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBaseId !== 'undefined') {
      toReturn['knowledgeBaseId'] = this.knowledgeBaseId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class KnowledgeSource {
  static fromProto(proto) {
    let m = new KnowledgeSource();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.config) {
      m.config = KnowledgeSourceConfig.fromProto(proto.config);
    }
    if (proto.knowledgeBaseKeys) {
      m.knowledgeBaseKeys = proto.knowledgeBaseKeys.map(KnowledgeBaseKey.fromProto);
    }
    if (proto.training) {
      m.training = KnowledgeSourceTraining.fromProto(proto.training);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.knowledgeBaseKeys !== 'undefined' && this.knowledgeBaseKeys !== null) {
      toReturn['knowledgeBaseKeys'] = 'toApiJson' in this.knowledgeBaseKeys ? this.knowledgeBaseKeys.toApiJson() : this.knowledgeBaseKeys;
    }
    if (typeof this.training !== 'undefined' && this.training !== null) {
      toReturn['training'] = 'toApiJson' in this.training ? this.training.toApiJson() : this.training;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfig {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfig();
    m = Object.assign(m, proto);
    if (proto.businessProfileConfig) {
      m.businessProfileConfig = KnowledgeSourceConfigBusinessProfileConfig.fromProto(proto.businessProfileConfig);
    }
    if (proto.customDataConfig) {
      m.customDataConfig = KnowledgeSourceConfigCustomDataConfig.fromProto(proto.customDataConfig);
    }
    if (proto.websiteScrapeConfig) {
      m.websiteScrapeConfig = KnowledgeSourceConfigWebsiteScrapeConfig.fromProto(proto.websiteScrapeConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessProfileConfig !== 'undefined' && this.businessProfileConfig !== null) {
      toReturn['businessProfileConfig'] = 'toApiJson' in this.businessProfileConfig ? this.businessProfileConfig.toApiJson() : this.businessProfileConfig;
    }
    if (typeof this.customDataConfig !== 'undefined' && this.customDataConfig !== null) {
      toReturn['customDataConfig'] = 'toApiJson' in this.customDataConfig ? this.customDataConfig.toApiJson() : this.customDataConfig;
    }
    if (typeof this.websiteScrapeConfig !== 'undefined' && this.websiteScrapeConfig !== null) {
      toReturn['websiteScrapeConfig'] = 'toApiJson' in this.websiteScrapeConfig ? this.websiteScrapeConfig.toApiJson() : this.websiteScrapeConfig;
    }
    return toReturn;
  }
}
class KnowledgeSourceKey {
  static fromProto(proto) {
    let m = new KnowledgeSourceKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSourceId !== 'undefined') {
      toReturn['knowledgeSourceId'] = this.knowledgeSourceId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class KnowledgeSourceTraining {
  static fromProto(proto) {
    let m = new KnowledgeSourceTraining();
    m = Object.assign(m, proto);
    if (proto.progress) {
      m.progress = enumStringToValue$4(TrainingProgress, proto.progress);
    }
    if (proto.totalUnits) {
      m.totalUnits = parseInt(proto.totalUnits, 10);
    }
    if (proto.completedUnits) {
      m.completedUnits = parseInt(proto.completedUnits, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.progress !== 'undefined') {
      toReturn['progress'] = this.progress;
    }
    if (typeof this.totalUnits !== 'undefined') {
      toReturn['totalUnits'] = this.totalUnits;
    }
    if (typeof this.completedUnits !== 'undefined') {
      toReturn['completedUnits'] = this.completedUnits;
    }
    return toReturn;
  }
}
class Namespace {
  static fromProto(proto) {
    let m = new Namespace();
    m = Object.assign(m, proto);
    if (proto.accountGroupNamespace) {
      m.accountGroupNamespace = NamespaceAccountGroupNamespace.fromProto(proto.accountGroupNamespace);
    }
    if (proto.partnerNamespace) {
      m.partnerNamespace = NamespacePartnerNamespace.fromProto(proto.partnerNamespace);
    }
    if (proto.adminNamespace) {
      m.adminNamespace = NamespaceAdminNamespace.fromProto(proto.adminNamespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupNamespace !== 'undefined' && this.accountGroupNamespace !== null) {
      toReturn['accountGroupNamespace'] = 'toApiJson' in this.accountGroupNamespace ? this.accountGroupNamespace.toApiJson() : this.accountGroupNamespace;
    }
    if (typeof this.partnerNamespace !== 'undefined' && this.partnerNamespace !== null) {
      toReturn['partnerNamespace'] = 'toApiJson' in this.partnerNamespace ? this.partnerNamespace.toApiJson() : this.partnerNamespace;
    }
    if (typeof this.adminNamespace !== 'undefined' && this.adminNamespace !== null) {
      toReturn['adminNamespace'] = 'toApiJson' in this.adminNamespace ? this.adminNamespace.toApiJson() : this.adminNamespace;
    }
    return toReturn;
  }
}
class NamespacePartnerNamespace {
  static fromProto(proto) {
    let m = new NamespacePartnerNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigWebsiteScrapeConfigScrapedPage {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigWebsiteScrapeConfigScrapedPage();
    m = Object.assign(m, proto);
    if (proto.lastScraped) {
      m.lastScraped = new Date(proto.lastScraped);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    if (typeof this.trainingEnabled !== 'undefined') {
      toReturn['trainingEnabled'] = this.trainingEnabled;
    }
    if (typeof this.lastScraped !== 'undefined' && this.lastScraped !== null) {
      toReturn['lastScraped'] = 'toApiJson' in this.lastScraped ? this.lastScraped.toApiJson() : this.lastScraped;
    }
    if (typeof this.doneScraping !== 'undefined') {
      toReturn['doneScraping'] = this.doneScraping;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigWebsiteScrapeConfig {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigWebsiteScrapeConfig();
    m = Object.assign(m, proto);
    if (proto.crawlMode) {
      m.crawlMode = enumStringToValue$4(WebsiteScrapeConfigCrawlMode, proto.crawlMode);
    }
    if (proto.scrapedPages) {
      m.scrapedPages = proto.scrapedPages.map(KnowledgeSourceConfigWebsiteScrapeConfigScrapedPage.fromProto);
    }
    if (proto.scrapeProgress) {
      m.scrapeProgress = enumStringToValue$4(WebsiteScrapeConfigProgress, proto.scrapeProgress);
    }
    if (proto.lastScraped) {
      m.lastScraped = new Date(proto.lastScraped);
    }
    if (proto.error) {
      m.error = KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigError.fromProto(proto.error);
    }
    if (proto.inProgressScrapedPages) {
      m.inProgressScrapedPages = proto.inProgressScrapedPages.map(KnowledgeSourceConfigWebsiteScrapeConfigScrapedPage.fromProto);
    }
    if (proto.options) {
      m.options = KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.crawlMode !== 'undefined') {
      toReturn['crawlMode'] = this.crawlMode;
    }
    if (typeof this.scrapedPages !== 'undefined' && this.scrapedPages !== null) {
      toReturn['scrapedPages'] = 'toApiJson' in this.scrapedPages ? this.scrapedPages.toApiJson() : this.scrapedPages;
    }
    if (typeof this.scrapeProgress !== 'undefined') {
      toReturn['scrapeProgress'] = this.scrapeProgress;
    }
    if (typeof this.lastScraped !== 'undefined' && this.lastScraped !== null) {
      toReturn['lastScraped'] = 'toApiJson' in this.lastScraped ? this.lastScraped.toApiJson() : this.lastScraped;
    }
    if (typeof this.error !== 'undefined' && this.error !== null) {
      toReturn['error'] = 'toApiJson' in this.error ? this.error.toApiJson() : this.error;
    }
    if (typeof this.inProgressScrapedPages !== 'undefined' && this.inProgressScrapedPages !== null) {
      toReturn['inProgressScrapedPages'] = 'toApiJson' in this.inProgressScrapedPages ? this.inProgressScrapedPages.toApiJson() : this.inProgressScrapedPages;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigError {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigError();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptions {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.disableAutoTraining !== 'undefined') {
      toReturn['disableAutoTraining'] = this.disableAutoTraining;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ChatAnswerCitation {
  static fromProto(proto) {
    let m = new ChatAnswerCitation();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(EmbeddingSourceType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class ChatBookingOption {
  static fromProto(proto) {
    let m = new ChatBookingOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.displayText !== 'undefined') {
      toReturn['displayText'] = this.displayText;
    }
    if (typeof this.scheduleId !== 'undefined') {
      toReturn['scheduleId'] = this.scheduleId;
    }
    return toReturn;
  }
}
class ChatMessage {
  static fromProto(proto) {
    let m = new ChatMessage();
    m = Object.assign(m, proto);
    if (proto.role) {
      m.role = enumStringToValue(ChatMessageRole, proto.role);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class CreateEmbeddingRequest {
  static fromProto(proto) {
    let m = new CreateEmbeddingRequest();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = EmbeddingMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class CreateEmbeddingResponse {
  static fromProto(proto) {
    let m = new CreateEmbeddingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new CreateKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeBase) {
      m.knowledgeBase = KnowledgeBase.fromProto(proto.knowledgeBase);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBase !== 'undefined' && this.knowledgeBase !== null) {
      toReturn['knowledgeBase'] = 'toApiJson' in this.knowledgeBase ? this.knowledgeBase.toApiJson() : this.knowledgeBase;
    }
    return toReturn;
  }
}
class CreateKnowledgeBaseResponse {
  static fromProto(proto) {
    let m = new CreateKnowledgeBaseResponse();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class CreateKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new CreateKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeSource) {
      m.knowledgeSource = KnowledgeSource.fromProto(proto.knowledgeSource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSource !== 'undefined' && this.knowledgeSource !== null) {
      toReturn['knowledgeSource'] = 'toApiJson' in this.knowledgeSource ? this.knowledgeSource.toApiJson() : this.knowledgeSource;
    }
    return toReturn;
  }
}
class CreateKnowledgeSourceResponse {
  static fromProto(proto) {
    let m = new CreateKnowledgeSourceResponse();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteAppRequest {
  static fromProto(proto) {
    let m = new DeleteAppRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteEmbeddingRequest {
  static fromProto(proto) {
    let m = new DeleteEmbeddingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embeddingId !== 'undefined') {
      toReturn['embeddingId'] = this.embeddingId;
    }
    return toReturn;
  }
}
class DeleteKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new DeleteKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new DeleteKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsRequestFilters {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.relationship) {
      m.relationship = EmbeddingRelationship.fromProto(proto.relationship);
    }
    if (proto.sourceType) {
      m.sourceType = proto.sourceType.map(v => enumStringToValue(EmbeddingSourceType, v));
    }
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue(EmbeddingVendorModel, proto.vendorModel);
    }
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.relationship !== 'undefined' && this.relationship !== null) {
      toReturn['relationship'] = 'toApiJson' in this.relationship ? this.relationship.toApiJson() : this.relationship;
    }
    if (typeof this.sourceType !== 'undefined') {
      toReturn['sourceType'] = this.sourceType;
    }
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.associatedAppId !== 'undefined') {
      toReturn['associatedAppId'] = this.associatedAppId;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
class ListAllKnowledgeSourcesForAppRequestFilters {
  static fromProto(proto) {
    let m = new ListAllKnowledgeSourcesForAppRequestFilters();
    m = Object.assign(m, proto);
    if (proto.configTypes) {
      m.configTypes = proto.configTypes.map(v => enumStringToValue(KnowledgeSourceConfigType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configTypes !== 'undefined') {
      toReturn['configTypes'] = this.configTypes;
    }
    return toReturn;
  }
}
class ListAppsRequestFilters {
  static fromProto(proto) {
    let m = new ListAppsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class ListEmbeddingsRequestFilters {
  static fromProto(proto) {
    let m = new ListEmbeddingsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.relationship) {
      m.relationship = EmbeddingRelationship.fromProto(proto.relationship);
    }
    if (proto.sourceType) {
      m.sourceType = proto.sourceType.map(v => enumStringToValue(EmbeddingSourceType, v));
    }
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue(EmbeddingVendorModel, proto.vendorModel);
    }
    if (proto.tags) {
      m.tags = proto.tags.map(Tag.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.relationship !== 'undefined' && this.relationship !== null) {
      toReturn['relationship'] = 'toApiJson' in this.relationship ? this.relationship.toApiJson() : this.relationship;
    }
    if (typeof this.sourceType !== 'undefined') {
      toReturn['sourceType'] = this.sourceType;
    }
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.associatedAppId !== 'undefined') {
      toReturn['associatedAppId'] = this.associatedAppId;
    }
    if (typeof this.tags !== 'undefined' && this.tags !== null) {
      toReturn['tags'] = 'toApiJson' in this.tags ? this.tags.toApiJson() : this.tags;
    }
    return toReturn;
  }
}
class ListKnowledgeBasesRequestFilters {
  static fromProto(proto) {
    let m = new ListKnowledgeBasesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class ListKnowledgeSourcesRequestFilters {
  static fromProto(proto) {
    let m = new ListKnowledgeSourcesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.configTypes) {
      m.configTypes = proto.configTypes.map(v => enumStringToValue(KnowledgeSourceConfigType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.configTypes !== 'undefined') {
      toReturn['configTypes'] = this.configTypes;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsRequest {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = FindSimilarEmbeddingsRequestFilters.fromProto(proto.filters);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    if (proto.rerankOptions) {
      m.rerankOptions = FindSimilarEmbeddingsRequestRerankOptions.fromProto(proto.rerankOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.query !== 'undefined') {
      toReturn['query'] = this.query;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.rerankOptions !== 'undefined' && this.rerankOptions !== null) {
      toReturn['rerankOptions'] = 'toApiJson' in this.rerankOptions ? this.rerankOptions.toApiJson() : this.rerankOptions;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsResponse {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsResponse();
    m = Object.assign(m, proto);
    if (proto.embeddings) {
      m.embeddings = proto.embeddings.map(FindSimilarEmbeddingsResponseMatch.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embeddings !== 'undefined' && this.embeddings !== null) {
      toReturn['embeddings'] = 'toApiJson' in this.embeddings ? this.embeddings.toApiJson() : this.embeddings;
    }
    return toReturn;
  }
}
class FunctionExecutionJob {
  static fromProto(proto) {
    let m = new FunctionExecutionJob();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(FunctionExecutionJobStatus, proto.status);
    }
    if (proto.result) {
      m.result = FunctionExecutionJobResult.fromProto(proto.result);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.result !== 'undefined' && this.result !== null) {
      toReturn['result'] = 'toApiJson' in this.result ? this.result.toApiJson() : this.result;
    }
    if (typeof this.nextJobId !== 'undefined') {
      toReturn['nextJobId'] = this.nextJobId;
    }
    return toReturn;
  }
}
class FunctionExecutionJobResult {
  static fromProto(proto) {
    let m = new FunctionExecutionJobResult();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class GenerateChatAnswerWithEmbeddingsRequest {
  static fromProto(proto) {
    let m = new GenerateChatAnswerWithEmbeddingsRequest();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = AppKey.fromProto(proto.appKey);
    }
    if (proto.chatHistory) {
      m.chatHistory = proto.chatHistory.map(ChatMessage.fromProto);
    }
    if (proto.options) {
      m.options = GenerateChatAnswerWithEmbeddingsRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.chatHistory !== 'undefined' && this.chatHistory !== null) {
      toReturn['chatHistory'] = 'toApiJson' in this.chatHistory ? this.chatHistory.toApiJson() : this.chatHistory;
    }
    if (typeof this.systemPrompt !== 'undefined') {
      toReturn['systemPrompt'] = this.systemPrompt;
    }
    if (typeof this.additionalInstructions !== 'undefined') {
      toReturn['additionalInstructions'] = this.additionalInstructions;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class GenerateChatAnswerWithEmbeddingsResponse {
  static fromProto(proto) {
    let m = new GenerateChatAnswerWithEmbeddingsResponse();
    m = Object.assign(m, proto);
    if (proto.citations) {
      m.citations = proto.citations.map(ChatAnswerCitation.fromProto);
    }
    if (proto.bookingOptions) {
      m.bookingOptions = proto.bookingOptions.map(ChatBookingOption.fromProto);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(KeyValuePair.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    if (typeof this.citations !== 'undefined' && this.citations !== null) {
      toReturn['citations'] = 'toApiJson' in this.citations ? this.citations.toApiJson() : this.citations;
    }
    if (typeof this.bookingOptions !== 'undefined' && this.bookingOptions !== null) {
      toReturn['bookingOptions'] = 'toApiJson' in this.bookingOptions ? this.bookingOptions.toApiJson() : this.bookingOptions;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.pendingJobId !== 'undefined') {
      toReturn['pendingJobId'] = this.pendingJobId;
    }
    return toReturn;
  }
}
class GetAppRequest {
  static fromProto(proto) {
    let m = new GetAppRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class GetAppResponse {
  static fromProto(proto) {
    let m = new GetAppResponse();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = App.fromProto(proto.app);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    return toReturn;
  }
}
class GetEmbeddingRequest {
  static fromProto(proto) {
    let m = new GetEmbeddingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetEmbeddingResponse {
  static fromProto(proto) {
    let m = new GetEmbeddingResponse();
    m = Object.assign(m, proto);
    if (proto.embedding) {
      m.embedding = Embedding.fromProto(proto.embedding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedding !== 'undefined' && this.embedding !== null) {
      toReturn['embedding'] = 'toApiJson' in this.embedding ? this.embedding.toApiJson() : this.embedding;
    }
    return toReturn;
  }
}
class GetFunctionExecutionJobRequest {
  static fromProto(proto) {
    let m = new GetFunctionExecutionJobRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetFunctionExecutionJobResponse {
  static fromProto(proto) {
    let m = new GetFunctionExecutionJobResponse();
    m = Object.assign(m, proto);
    if (proto.job) {
      m.job = FunctionExecutionJob.fromProto(proto.job);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.job !== 'undefined' && this.job !== null) {
      toReturn['job'] = 'toApiJson' in this.job ? this.job.toApiJson() : this.job;
    }
    return toReturn;
  }
}
class GetKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new GetKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.includeKnowledgeSourceKeys !== 'undefined') {
      toReturn['includeKnowledgeSourceKeys'] = this.includeKnowledgeSourceKeys;
    }
    return toReturn;
  }
}
class GetKnowledgeBaseResponse {
  static fromProto(proto) {
    let m = new GetKnowledgeBaseResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeBase) {
      m.knowledgeBase = KnowledgeBase.fromProto(proto.knowledgeBase);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBase !== 'undefined' && this.knowledgeBase !== null) {
      toReturn['knowledgeBase'] = 'toApiJson' in this.knowledgeBase ? this.knowledgeBase.toApiJson() : this.knowledgeBase;
    }
    return toReturn;
  }
}
class GetKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new GetKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class GetKnowledgeSourceResponse {
  static fromProto(proto) {
    let m = new GetKnowledgeSourceResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeSource) {
      m.knowledgeSource = KnowledgeSource.fromProto(proto.knowledgeSource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSource !== 'undefined' && this.knowledgeSource !== null) {
      toReturn['knowledgeSource'] = 'toApiJson' in this.knowledgeSource ? this.knowledgeSource.toApiJson() : this.knowledgeSource;
    }
    return toReturn;
  }
}
class KeyValuePair {
  static fromProto(proto) {
    let m = new KeyValuePair();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ListAllAppsForKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new ListAllAppsForKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSourceId !== 'undefined') {
      toReturn['knowledgeSourceId'] = this.knowledgeSourceId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class ListAllAppsForKnowledgeSourceResponse {
  static fromProto(proto) {
    let m = new ListAllAppsForKnowledgeSourceResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(App.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    return toReturn;
  }
}
class ListAllKnowledgeSourcesForAppRequest {
  static fromProto(proto) {
    let m = new ListAllKnowledgeSourcesForAppRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.filters) {
      m.filters = ListAllKnowledgeSourcesForAppRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAllKnowledgeSourcesForAppResponse {
  static fromProto(proto) {
    let m = new ListAllKnowledgeSourcesForAppResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeSources) {
      m.knowledgeSources = proto.knowledgeSources.map(KnowledgeSource.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSources !== 'undefined' && this.knowledgeSources !== null) {
      toReturn['knowledgeSources'] = 'toApiJson' in this.knowledgeSources ? this.knowledgeSources.toApiJson() : this.knowledgeSources;
    }
    return toReturn;
  }
}
class ListAppsRequest {
  static fromProto(proto) {
    let m = new ListAppsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListAppsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class ListAppsResponse {
  static fromProto(proto) {
    let m = new ListAppsResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(App.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListEmbeddingsRequest {
  static fromProto(proto) {
    let m = new ListEmbeddingsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListEmbeddingsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListEmbeddingsResponse {
  static fromProto(proto) {
    let m = new ListEmbeddingsResponse();
    m = Object.assign(m, proto);
    if (proto.embeddings) {
      m.embeddings = proto.embeddings.map(Embedding.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embeddings !== 'undefined' && this.embeddings !== null) {
      toReturn['embeddings'] = 'toApiJson' in this.embeddings ? this.embeddings.toApiJson() : this.embeddings;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListKnowledgeBasesRequest {
  static fromProto(proto) {
    let m = new ListKnowledgeBasesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListKnowledgeBasesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.includeKnowledgeSourceKeys !== 'undefined') {
      toReturn['includeKnowledgeSourceKeys'] = this.includeKnowledgeSourceKeys;
    }
    return toReturn;
  }
}
class ListKnowledgeBasesResponse {
  static fromProto(proto) {
    let m = new ListKnowledgeBasesResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeBases) {
      m.knowledgeBases = proto.knowledgeBases.map(KnowledgeBase.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBases !== 'undefined' && this.knowledgeBases !== null) {
      toReturn['knowledgeBases'] = 'toApiJson' in this.knowledgeBases ? this.knowledgeBases.toApiJson() : this.knowledgeBases;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListKnowledgeSourcesRequest {
  static fromProto(proto) {
    let m = new ListKnowledgeSourcesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListKnowledgeSourcesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class ListKnowledgeSourcesResponse {
  static fromProto(proto) {
    let m = new ListKnowledgeSourcesResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeSources) {
      m.knowledgeSources = proto.knowledgeSources.map(KnowledgeSource.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSources !== 'undefined' && this.knowledgeSources !== null) {
      toReturn['knowledgeSources'] = 'toApiJson' in this.knowledgeSources ? this.knowledgeSources.toApiJson() : this.knowledgeSources;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsResponseMatch {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsResponseMatch();
    m = Object.assign(m, proto);
    if (proto.embedding) {
      m.embedding = Embedding.fromProto(proto.embedding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedding !== 'undefined' && this.embedding !== null) {
      toReturn['embedding'] = 'toApiJson' in this.embedding ? this.embedding.toApiJson() : this.embedding;
    }
    if (typeof this.similarity !== 'undefined') {
      toReturn['similarity'] = this.similarity;
    }
    return toReturn;
  }
}
class GenerateChatAnswerWithEmbeddingsRequestOptions {
  static fromProto(proto) {
    let m = new GenerateChatAnswerWithEmbeddingsRequestOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeAllCitations !== 'undefined') {
      toReturn['includeAllCitations'] = this.includeAllCitations;
    }
    if (typeof this.enableAsyncFunctions !== 'undefined') {
      toReturn['enableAsyncFunctions'] = this.enableAsyncFunctions;
    }
    return toReturn;
  }
}
class RefreshBusinessProfileEmbeddingsRequest {
  static fromProto(proto) {
    let m = new RefreshBusinessProfileEmbeddingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsRequestRerankOptions {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsRequestRerankOptions();
    m = Object.assign(m, proto);
    if (proto.method) {
      m.method = enumStringToValue(EmbeddingRerankerMethod, proto.method);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.method !== 'undefined') {
      toReturn['method'] = this.method;
    }
    return toReturn;
  }
}
class ScrapeWebsiteRequest {
  static fromProto(proto) {
    let m = new ScrapeWebsiteRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSourceId !== 'undefined') {
      toReturn['knowledgeSourceId'] = this.knowledgeSourceId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class ScrapeWebsiteResponse {
  static fromProto(proto) {
    let m = new ScrapeWebsiteResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class SetAppsForKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new SetAppsForKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeSourceKey) {
      m.knowledgeSourceKey = KnowledgeSourceKey.fromProto(proto.knowledgeSourceKey);
    }
    if (proto.appKeys) {
      m.appKeys = proto.appKeys.map(AppKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSourceKey !== 'undefined' && this.knowledgeSourceKey !== null) {
      toReturn['knowledgeSourceKey'] = 'toApiJson' in this.knowledgeSourceKey ? this.knowledgeSourceKey.toApiJson() : this.knowledgeSourceKey;
    }
    if (typeof this.appKeys !== 'undefined' && this.appKeys !== null) {
      toReturn['appKeys'] = 'toApiJson' in this.appKeys ? this.appKeys.toApiJson() : this.appKeys;
    }
    return toReturn;
  }
}
class TuneAIModelRequest {
  static fromProto(proto) {
    let m = new TuneAIModelRequest();
    m = Object.assign(m, proto);
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue(EmbeddingVendorModel, proto.vendorModel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.outputPath !== 'undefined') {
      toReturn['outputPath'] = this.outputPath;
    }
    if (typeof this.queriesPath !== 'undefined') {
      toReturn['queriesPath'] = this.queriesPath;
    }
    if (typeof this.corpusPath !== 'undefined') {
      toReturn['corpusPath'] = this.corpusPath;
    }
    if (typeof this.trainingLabelPath !== 'undefined') {
      toReturn['trainingLabelPath'] = this.trainingLabelPath;
    }
    if (typeof this.modelDisplayName !== 'undefined') {
      toReturn['modelDisplayName'] = this.modelDisplayName;
    }
    return toReturn;
  }
}
class UpdateEmbeddingRequest {
  static fromProto(proto) {
    let m = new UpdateEmbeddingRequest();
    m = Object.assign(m, proto);
    if (proto.embedding) {
      m.embedding = Embedding.fromProto(proto.embedding);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedding !== 'undefined' && this.embedding !== null) {
      toReturn['embedding'] = 'toApiJson' in this.embedding ? this.embedding.toApiJson() : this.embedding;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new UpdateKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeBase) {
      m.knowledgeBase = KnowledgeBase.fromProto(proto.knowledgeBase);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBase !== 'undefined' && this.knowledgeBase !== null) {
      toReturn['knowledgeBase'] = 'toApiJson' in this.knowledgeBase ? this.knowledgeBase.toApiJson() : this.knowledgeBase;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new UpdateKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeSource) {
      m.knowledgeSource = KnowledgeSource.fromProto(proto.knowledgeSource);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSource !== 'undefined' && this.knowledgeSource !== null) {
      toReturn['knowledgeSource'] = 'toApiJson' in this.knowledgeSource ? this.knowledgeSource.toApiJson() : this.knowledgeSource;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertAppRequest {
  static fromProto(proto) {
    let m = new UpsertAppRequest();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = App.fromProto(proto.app);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    return toReturn;
  }
}
class UpsertKnowledgeForAppRequest {
  static fromProto(proto) {
    let m = new UpsertKnowledgeForAppRequest();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = App.fromProto(proto.app);
    }
    if (proto.knowledgeSourceKeys) {
      m.knowledgeSourceKeys = proto.knowledgeSourceKeys.map(KnowledgeSourceKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    if (typeof this.knowledgeSourceKeys !== 'undefined' && this.knowledgeSourceKeys !== null) {
      toReturn['knowledgeSourceKeys'] = 'toApiJson' in this.knowledgeSourceKeys ? this.knowledgeSourceKeys.toApiJson() : this.knowledgeSourceKeys;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'embeddings-api.vendasta-local.com',
  'test': '',
  'demo': 'embeddings-demo.apigateway.co',
  'prod': 'embeddings-prod.apigateway.co',
  'production': 'embeddings-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EmbeddingApiService = /*#__PURE__*/(() => {
  class EmbeddingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createEmbedding(r) {
      const request = r.toApiJson ? r : new CreateEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/CreateEmbedding", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateEmbeddingResponse.fromProto(resp)));
    }
    getEmbedding(r) {
      const request = r.toApiJson ? r : new GetEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/GetEmbedding", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmbeddingResponse.fromProto(resp)));
    }
    updateEmbedding(r) {
      const request = r.toApiJson ? r : new UpdateEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/UpdateEmbedding", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteEmbedding(r) {
      const request = r.toApiJson ? r : new DeleteEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/DeleteEmbedding", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listEmbeddings(r) {
      const request = r.toApiJson ? r : new ListEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/ListEmbeddings", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEmbeddingsResponse.fromProto(resp)));
    }
    findSimilarEmbeddings(r) {
      const request = r.toApiJson ? r : new FindSimilarEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/FindSimilarEmbeddings", request.toApiJson(), this.apiOptions()).pipe(map(resp => FindSimilarEmbeddingsResponse.fromProto(resp)));
    }
  }
  EmbeddingApiService.ɵfac = function EmbeddingApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmbeddingApiService)();
  };
  EmbeddingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmbeddingApiService,
    factory: EmbeddingApiService.ɵfac,
    providedIn: 'root'
  });
  return EmbeddingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmbeddingService = /*#__PURE__*/(() => {
  class EmbeddingService {
    constructor(api) {
      this.api = api;
    }
    createEmbedding(req) {
      return this.api.createEmbedding(req).pipe(map(resp => resp.id));
    }
    getEmbedding(req) {
      return this.api.getEmbedding(req).pipe(map(resp => resp.embedding));
    }
    updateEmbedding(req) {
      return this.api.updateEmbedding(req).pipe(map(() => true));
    }
    listEmbeddings(req) {
      return this.api.listEmbeddings(req);
    }
    deleteEmbedding(req) {
      return this.api.deleteEmbedding(req).pipe(map(() => true));
    }
  }
  EmbeddingService.ɵfac = function EmbeddingService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmbeddingService)(i0.ɵɵinject(EmbeddingApiService));
  };
  EmbeddingService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmbeddingService,
    factory: EmbeddingService.ɵfac,
    providedIn: 'root'
  });
  return EmbeddingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AIAssistantApiService = /*#__PURE__*/(() => {
  class AIAssistantApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateChatAnswerWithEmbeddings(r) {
      const request = r.toApiJson ? r : new GenerateChatAnswerWithEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.AIAssistantService/GenerateChatAnswerWithEmbeddings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateChatAnswerWithEmbeddingsResponse.fromProto(resp)));
    }
    getFunctionExecutionJob(r) {
      const request = r.toApiJson ? r : new GetFunctionExecutionJobRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.AIAssistantService/GetFunctionExecutionJob", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFunctionExecutionJobResponse.fromProto(resp)));
    }
  }
  AIAssistantApiService.ɵfac = function AIAssistantApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AIAssistantApiService)();
  };
  AIAssistantApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AIAssistantApiService,
    factory: AIAssistantApiService.ɵfac,
    providedIn: 'root'
  });
  return AIAssistantApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AutomatedEmbeddingsApiService = /*#__PURE__*/(() => {
  class AutomatedEmbeddingsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    scrapeWebsite(r) {
      const request = r.toApiJson ? r : new ScrapeWebsiteRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.AutomatedEmbeddingsService/ScrapeWebsite", request.toApiJson(), this.apiOptions()).pipe(map(resp => ScrapeWebsiteResponse.fromProto(resp)));
    }
    refreshBusinessProfileEmbeddings(r) {
      const request = r.toApiJson ? r : new RefreshBusinessProfileEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.AutomatedEmbeddingsService/RefreshBusinessProfileEmbeddings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    refreshAllBusinessProfileEmbeddings() {
      return this.http.post(this._host + "/embeddings.v1alpha1.AutomatedEmbeddingsService/RefreshAllBusinessProfileEmbeddings", {}, {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AutomatedEmbeddingsApiService.ɵfac = function AutomatedEmbeddingsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutomatedEmbeddingsApiService)();
  };
  AutomatedEmbeddingsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomatedEmbeddingsApiService,
    factory: AutomatedEmbeddingsApiService.ɵfac,
    providedIn: 'root'
  });
  return AutomatedEmbeddingsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let KnowledgeBaseApiService = /*#__PURE__*/(() => {
  class KnowledgeBaseApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createKnowledgeBase(r) {
      const request = r.toApiJson ? r : new CreateKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeBase", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateKnowledgeBaseResponse.fromProto(resp)));
    }
    getKnowledgeBase(r) {
      const request = r.toApiJson ? r : new GetKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeBase", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetKnowledgeBaseResponse.fromProto(resp)));
    }
    updateKnowledgeBase(r) {
      const request = r.toApiJson ? r : new UpdateKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeBase", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteKnowledgeBase(r) {
      const request = r.toApiJson ? r : new DeleteKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeBase", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listKnowledgeBases(r) {
      const request = r.toApiJson ? r : new ListKnowledgeBasesRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeBases", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListKnowledgeBasesResponse.fromProto(resp)));
    }
    createKnowledgeSource(r) {
      const request = r.toApiJson ? r : new CreateKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateKnowledgeSourceResponse.fromProto(resp)));
    }
    getKnowledgeSource(r) {
      const request = r.toApiJson ? r : new GetKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetKnowledgeSourceResponse.fromProto(resp)));
    }
    updateKnowledgeSource(r) {
      const request = r.toApiJson ? r : new UpdateKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteKnowledgeSource(r) {
      const request = r.toApiJson ? r : new DeleteKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listKnowledgeSources(r) {
      const request = r.toApiJson ? r : new ListKnowledgeSourcesRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeSources", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListKnowledgeSourcesResponse.fromProto(resp)));
    }
    upsertApp(r) {
      const request = r.toApiJson ? r : new UpsertAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpsertApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getApp(r) {
      const request = r.toApiJson ? r : new GetAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/GetApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppResponse.fromProto(resp)));
    }
    deleteApp(r) {
      const request = r.toApiJson ? r : new DeleteAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/DeleteApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listApps(r) {
      const request = r.toApiJson ? r : new ListAppsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAppsResponse.fromProto(resp)));
    }
    listAllKnowledgeSourcesForApp(r) {
      const request = r.toApiJson ? r : new ListAllKnowledgeSourcesForAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListAllKnowledgeSourcesForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllKnowledgeSourcesForAppResponse.fromProto(resp)));
    }
    listAllAppsForKnowledgeSource(r) {
      const request = r.toApiJson ? r : new ListAllAppsForKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListAllAppsForKnowledgeSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllAppsForKnowledgeSourceResponse.fromProto(resp)));
    }
    upsertKnowledgeForApp(r) {
      const request = r.toApiJson ? r : new UpsertKnowledgeForAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpsertKnowledgeForApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setAppsForKnowledgeSource(r) {
      const request = r.toApiJson ? r : new SetAppsForKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/SetAppsForKnowledgeSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    tuneAiModel(r) {
      const request = r.toApiJson ? r : new TuneAIModelRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/TuneAIModel", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  KnowledgeBaseApiService.ɵfac = function KnowledgeBaseApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || KnowledgeBaseApiService)();
  };
  KnowledgeBaseApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: KnowledgeBaseApiService,
    factory: KnowledgeBaseApiService.ɵfac,
    providedIn: 'root'
  });
  return KnowledgeBaseApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let KnowledgeBaseService = /*#__PURE__*/(() => {
  class KnowledgeBaseService {
    constructor(api, automatedServiceApi) {
      this.api = api;
      this.automatedServiceApi = automatedServiceApi;
    }
    getApp(req) {
      return this.api.getApp(req).pipe(map(resp => resp.app));
    }
    listApps(req) {
      return this.api.listApps(req).pipe(map(resp => resp));
    }
    updateKnowledgeBase(req) {
      return this.api.updateKnowledgeBase(req).pipe(map(() => true));
    }
    getKnowledgeSource(req) {
      return this.api.getKnowledgeSource(req).pipe(map(resp => resp.knowledgeSource));
    }
    createKnowledgeSource(req) {
      return this.api.createKnowledgeSource(req).pipe(map(resp => resp));
    }
    updateKnowledgeSource(req) {
      return this.api.updateKnowledgeSource(req).pipe(map(() => true));
    }
    deleteKnowledgeSource(req) {
      return this.api.deleteKnowledgeSource(req).pipe(map(() => true));
    }
    listKnowledgeSources(req) {
      return this.api.listKnowledgeSources(req).pipe(map(resp => resp));
    }
    listAllKnowledgeSourcesForApp(req) {
      return this.api.listAllKnowledgeSourcesForApp(req);
    }
    listAllAppsForKnowledgeSource(req) {
      return this.api.listAllAppsForKnowledgeSource(req);
    }
    upsertKnowledgeForApp(req) {
      return this.api.upsertKnowledgeForApp(req).pipe(map(() => true));
    }
    setAppsForKnowledgeSource(req) {
      return this.api.setAppsForKnowledgeSource(req).pipe(map(() => true));
    }
    scrapeWebsite(req) {
      return this.automatedServiceApi.scrapeWebsite(req);
    }
  }
  KnowledgeBaseService.ɵfac = function KnowledgeBaseService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || KnowledgeBaseService)(i0.ɵɵinject(KnowledgeBaseApiService), i0.ɵɵinject(AutomatedEmbeddingsApiService));
  };
  KnowledgeBaseService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: KnowledgeBaseService,
    factory: KnowledgeBaseService.ɵfac,
    providedIn: 'root'
  });
  return KnowledgeBaseService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, App, AppKey, ChatAnswerCitation, ChatBookingOption, ChatMessage, ChatMessageRole, CreateEmbeddingRequest, CreateEmbeddingResponse, CreateKnowledgeBaseRequest, CreateKnowledgeBaseResponse, CreateKnowledgeSourceRequest, CreateKnowledgeSourceResponse, DeleteAppRequest, DeleteEmbeddingRequest, DeleteKnowledgeBaseRequest, DeleteKnowledgeSourceRequest, Embedding, EmbeddingCitation, EmbeddingMetadata, EmbeddingRelationship, EmbeddingRelationshipAccountGroup, EmbeddingRelationshipAdmin, EmbeddingRelationshipPartner, EmbeddingRerankerMethod, EmbeddingService, EmbeddingSourceType, EmbeddingVendorModel, FieldMask, FindSimilarEmbeddingsRequest, FindSimilarEmbeddingsRequestFilters, FindSimilarEmbeddingsRequestRerankOptions, FindSimilarEmbeddingsResponse, FindSimilarEmbeddingsResponseMatch, FunctionExecutionJob, FunctionExecutionJobResult, FunctionExecutionJobStatus, GenerateChatAnswerWithEmbeddingsRequest, GenerateChatAnswerWithEmbeddingsRequestOptions, GenerateChatAnswerWithEmbeddingsResponse, GetAppRequest, GetAppResponse, GetEmbeddingRequest, GetEmbeddingResponse, GetFunctionExecutionJobRequest, GetFunctionExecutionJobResponse, GetKnowledgeBaseRequest, GetKnowledgeBaseResponse, GetKnowledgeSourceRequest, GetKnowledgeSourceResponse, KeyValuePair, KnowledgeBase, KnowledgeBaseKey, KnowledgeBaseService, KnowledgeSource, KnowledgeSourceConfig, KnowledgeSourceConfigBusinessProfileConfig, KnowledgeSourceConfigCustomDataConfig, KnowledgeSourceConfigType, KnowledgeSourceConfigWebsiteScrapeConfig, KnowledgeSourceConfigWebsiteScrapeConfigScrapedPage, KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeConfigError, KnowledgeSourceConfigWebsiteScrapeConfigWebsiteScrapeOptions, KnowledgeSourceKey, KnowledgeSourceTraining, ListAllAppsForKnowledgeSourceRequest, ListAllAppsForKnowledgeSourceResponse, ListAllKnowledgeSourcesForAppRequest, ListAllKnowledgeSourcesForAppRequestFilters, ListAllKnowledgeSourcesForAppResponse, ListAppsRequest, ListAppsRequestFilters, ListAppsResponse, ListEmbeddingsRequest, ListEmbeddingsRequestFilters, ListEmbeddingsResponse, ListKnowledgeBasesRequest, ListKnowledgeBasesRequestFilters, ListKnowledgeBasesResponse, ListKnowledgeSourcesRequest, ListKnowledgeSourcesRequestFilters, ListKnowledgeSourcesResponse, Namespace, NamespaceAccountGroupNamespace, NamespaceAdminNamespace, NamespacePartnerNamespace, PagedRequestOptions, PagedResponseMetadata, RefreshAccountGroupWebsiteEmbeddingsProgress, RefreshBusinessProfileEmbeddingsRequest, ScrapeWebsiteRequest, ScrapeWebsiteResponse, SetAppsForKnowledgeSourceRequest, Tag, TrainingProgress, TuneAIModelRequest, UpdateEmbeddingRequest, UpdateKnowledgeBaseRequest, UpdateKnowledgeSourceRequest, UpsertAppRequest, UpsertKnowledgeForAppRequest, WebsiteScrapeConfigCrawlMode, WebsiteScrapeConfigProgress };
